import { render, staticRenderFns } from "./ColorsGridUsageExamplesSection.vue?vue&type=template&id=314cb2d6"
import script from "./ColorsGridUsageExamplesSection.vue?vue&type=script&lang=ts"
export * from "./ColorsGridUsageExamplesSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsGridUsageExamplesSection.vue?vue&type=style&index=0&id=314cb2d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports